export default __webpack_public_path__ + "static/media/miko-pose.4c71d92f.png";